// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Stdlib_List = require("@rescript/runtime/lib/js/Stdlib_List.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let SystemMessage = require("../../uikit/reason/molecules/SystemMessage/SystemMessage.bs.js");
let SystemMessages = require("./SystemMessages.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let ReactTransitionGroup = require("react-transition-group");

function SystemMessageDisplay$SystemMessage(props) {
  let dismiss = props.dismiss;
  let message = props.message;
  return JsxRuntime.jsx(SystemMessage.make, {
    id: message.id,
    time: message.time,
    text: message.text,
    type_: message.type_,
    dismissible: Stdlib_Option.map(dismiss, param => true),
    handleOnDismiss: dismiss,
    children: props.children
  });
}

let SystemMessage$1 = {
  make: SystemMessageDisplay$SystemMessage
};

function SystemMessageDisplay$Spread(props) {
  return React.cloneElement(props.children, props.props);
}

let Spread = {
  make: SystemMessageDisplay$Spread
};

function SystemMessageDisplay(props) {
  let match = SystemMessages.useSystemMessages();
  let removeMessage = match.removeMessage;
  return JsxRuntime.jsx(SystemMessageDisplay$Spread, {
    props: {
      "aria-live": "polite"
    },
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(ReactTransitionGroup.TransitionGroup, {
        children: Stdlib_List.toArray(Stdlib_List.map(match.messages, msg => {
          let render = msg.renderButtons;
          return JsxRuntime.jsx(ReactTransitionGroup.CSSTransition, {
            classNames: {
              enter: "system-message-enter",
              enterActive: "system-message-enter-active",
              exit: "system-message-exit",
              exitActive: "system-message-exit-active"
            },
            timeout: {
              enter: 500,
              exit: 500
            },
            children: JsxRuntime.jsx(SystemMessageDisplay$SystemMessage, {
              message: msg,
              dismiss: msg.dismissable ? removeMessage : undefined,
              children: render !== undefined ? render(msg.id) : null
            }, msg.id)
          }, msg.id);
        }))
      }),
      className: "sticky top-0 z-[200]"
    })
  });
}

let make = SystemMessageDisplay;

let $$default = SystemMessageDisplay;

exports.SystemMessage = SystemMessage$1;
exports.Spread = Spread;
exports.make = make;
exports.default = $$default;
exports.__esModule = true;
/* react Not a pure module */
